export default function Icons({data}) {
    const Icon = ({item}) => (
        <div className="icon">
            {item.svg}
            <p className="name">{item.name}</p>
            <p className="number">{item.number}</p>
        </div>
    );
    return data && data.filter(item => item.number !== '0').map((item, index) => <Icon key={index} item={item}/>)
}